import { marker as _ } from '@jsverse/transloco-keys-manager/marker';
import { AppNavigationItem } from './app-navigation-item.model';
import { RequiredScopes } from './required-scopes.model';

export const untranslatedNavigationItems: AppNavigationItem[] = [
  {
    label: _('i18n.Shift.List.Title'),
    link: 'shifts',
    icon: 'punch_clock',
    [RequiredScopes]: ['shifts:read'],
  },
  {
    label: _('i18n.Deployment.List.Title'),
    link: 'deployments',
    icon: 'assignment',
    [RequiredScopes]: ['deployments:read'],
  },
  {
    label: _('i18n.Vehicle.List.Title'),
    icon: 'local_shipping',
    link: 'vehicles',
    [RequiredScopes]: ['vehicles:read'],
  },
  {
    label: _('i18n.VehiclePlanning.List.Title'),
    link: 'planning/vehicles',
    icon: 'departure_board',
    routerLinkActiveOptions: {
      exact: true,
    },
    [RequiredScopes]: ['deployments:read'],
  },
  {
    label: _('i18n.Driver.List.Title'),
    icon: 'person',
    link: 'drivers',
    [RequiredScopes]: ['drivers:read'],
  },
  {
    label: _('i18n.DriverPlanning.List.Title'),
    link: 'planning/drivers',
    icon: 'co_present',
    routerLinkActiveOptions: {
      exact: true,
    },
    [RequiredScopes]: ['deployments:read'],
  },
];
